import { DefaultResponseWithData } from "./system";
import { VehicleComplexity } from "./Vehicle";

export enum VehicleProductionLine {
  MainLine = 0,
  OffLine = 1,
}

export interface IPlannerVehicleRow {
  id: string;
  vrm: string;
  stockNumber: string | null;
  combinedMake: string | null;
  combinedModel: string | null;
  bodyStyle: string | null;
  complexity: VehicleComplexity;
  productionLine: VehicleProductionLine;
  locationId: string | null;
  locationName: string | null;
  arrivalDate: string | null;
  collectedOn: string | null;
  vehicleImageUrl: string | null;
  dismantlingBayId: string | null;
  plannedDismantlingOn: string | null;
  dismantlingBayOrder: number;
  partsCount: number;
}

export interface IAllocateVehicleRequest {
  dismantlingBayId: string;
  plannedOn: string;
}

export interface IReorderBayRequest {
  dismantlingBayId: string;
  plannedOn: string;
  vehicleIds: string[];
}

export interface IPlannerVehicleRowsResponse extends DefaultResponseWithData<IPlannerVehicleRow[]> {}
export interface IPlannerVehicleRowResponse extends DefaultResponseWithData<IPlannerVehicleRow> {}

export type PlannerView = "Bays" | "ProductionLine";
export type PlannerColourBy = "Complexity" | "Age";
export type PlannerSort = "Oldest" | "Newest";
export type PlannerComplexityFilter = "All" | "Easy" | "Medium" | "Hard";
export type PlannerDayRange = 1 | 3 | 5 | 7;

export interface IPlannerDragItem {
  vehicleId: string;
  currentBayId: string | null;
  currentPlannedOn: string | null;
}
